import { Path } from 'src/shared/design-system/Utilities/SVG';
import { BaseIcon } from './BaseIcon';

export const Appetizer = () => (
  <BaseIcon>
    <Path
      d={`M9.3,0.3C9.3,0.1,9.2,0,9,0C8.9,0,8.7,0.1,8.7,0.3c0,0.2-0.1,0.4-0.2,0.5C8.3,1,8.1,1.3,8.1,1.8s0.2,0.8,
          0.4,1C8.6,2.9,8.7,3,8.7,3.3c0,0.2-0.1,0.4-0.2,0.5C8.3,4,8.1,4.3,8.1,4.7c0,0.2,0.1,0.3,0.3,0.3s0.3-0.1,
          0.3-0.3c0-0.2,0.1-0.4,0.2-0.5c0.2-0.2,0.4-0.5,0.4-1c0-0.5-0.2-0.8-0.4-1C8.8,2.2,8.8,2,8.8,1.8c0-0.2,
          0.1-0.4,0.2-0.5C9.1,1.1,9.3,0.8,9.3,0.3z M7.3,2.6c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3c0,
          0.2-0.1,0.4-0.2,0.5c-0.2,0.2-0.4,0.5-0.4,1s0.2,0.8,0.4,1c0.1,0.2,0.2,0.3,0.2,0.5c0,0.2,0.1,0.3,0.3,
          0.3c0.2,0,0.3-0.1,0.3-0.3c0-0.5-0.2-0.8-0.4-1C6.8,4.4,6.7,4.3,6.7,4.1c0-0.2,0.1-0.4,0.2-0.5C7.1,3.4,
          7.3,3.1,7.3,2.6z M11.3,2.6c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3c0,0.2-0.1,0.4-0.2,0.5c-0.2,
          0.2-0.4,0.5-0.4,1s0.2,0.8,0.4,1c0.1,0.2,0.2,0.3,0.2,0.5c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.3-0.1,
          0.3-0.3c0-0.5-0.2-0.8-0.4-1c-0.1-0.2-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5C11.1,3.4,11.3,3.1,11.3,
          2.6z M15.6,7.4H3.8L2,2.9c0,0,0,0,0,0C1.9,2.6,1.7,2.4,1.4,2.3c-0.3-0.1-0.5-0.1-0.8,0C0.3,2.5,0.2,2.7,
          0.1,3C0,3.2,0,3.5,0.1,3.8c0,0,0,0,0,0l1.8,3.6c-0.2,0-0.3,0.2-0.3,0.4v1.5c0,2.3,1.6,4.3,3.8,4.6v1.7c0,
          0.2,0.1,0.3,0.3,0.3h6.2c0.2,0,0.3-0.1,0.3-0.3v-1.7c2.1-0.3,3.8-2.3,3.8-4.6V7.8C16,7.5,15.8,7.4,15.6,
          7.4z M2.6,7.4L0.7,3.5c0-0.1-0.1-0.2,0-0.3h0c0-0.1,0.1-0.2,0.2-0.2s0.2-0.1,0.3,0C1.3,3,1.4,3,1.4,
          3.1l1.7,4.2H2.6z M11.6,15.3H6V14c0,0,0,0,0,0h5.5c0,0,0,0,0,0V15.3z`}
    />
  </BaseIcon>
);
